/**
 * ScenePicking - Generic scene query primitives usable by any tool.
 *
 * Provides simple "what's under the mouse" functions that return raw results
 * without any tool-specific conditions. Each tool decides what to do with the result.
 */

import * as THREE from 'three';
import { Viewer } from '../../../../viewer/viewer';
import { PointoramaPlane } from '../../../../utils/PointoramaPlane';
import { Utils } from '../../../../utils';

/** Get the raw 3D point cloud intersection under the mouse. No snapping, no filtering. */
export function getPointCloudIntersection(viewer: Viewer, mouse: THREE.Vector2): THREE.Vector3 | null {
  const I = Utils.getMousePointCloudIntersection(mouse, viewer.scene.getActiveCamera(), viewer, viewer.scene.pointclouds, { pickClipped: false });
  return I && 'location' in I ? I.location : null;
}

/**
 * Resolve the effective drawing plane for the current view mode.
 * Returns the explicit plane if provided, or the 2D mode associated plane, or null.
 */
export function getEffectiveDrawingPlane(viewer: Viewer, explicitPlane?: PointoramaPlane | null): PointoramaPlane | null {
  return explicitPlane || (viewer.viewerMode.in2DMode ? viewer.viewerMode.associatedPlane : null) || null;
}
